import { all, call, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywordSavings.actions'

function* exportKeywordSavingsExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportSavingsExcel,
    requestShared: agent.Share.exportShareSavingsExcel
  })
}

function* exportKeywordSavingsCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportSavingsCSV,
    requestShared: agent.Share.exportShareSavingsCSV
  })
}

export default function* keywordSavingsSagas() {
  yield all([
    takeLatest(actions.exportDomainKeywordSavingsExcel.type, exportKeywordSavingsExcelSaga),
    takeLatest(actions.exportDomainKeywordSavingsCSV.type, exportKeywordSavingsCSVSaga)
  ])
}
